module.exports = __webpack_public_path__ + "static/media/10.de568c40.svg";